export function normalizeSamagriTagIds(tagIds?: number[]): number[] {
  return (tagIds ?? []).filter((id): id is number => typeof id === 'number' && Number.isFinite(id));
}

export function appendSamagriTagIdsToFormData(formData: FormData, tagIds?: number[]) {
  formData.append('tagIds', JSON.stringify(normalizeSamagriTagIds(tagIds)));
}
